import React, { FC } from 'react';
import anime from 'animejs';
import classnames from 'classnames';
import { useTheme } from 'contexts/ThemeContext';
import styles from './Hamburger.module.scss';

interface HamburgerProps {
    isActive: boolean;
    onToggle?: (open: boolean) => void;
}

const hamburgerSolidPath =
    'M3.0204,19.5375v-2.35H21v2.35H3.0204Zm0-6.35v-2.35H21v2.35H3.0204Zm-.0204-6.35v-2.35H20.9796v2.35H3Z';
const hamburgerOutlinePath = 'M3,18.25v-1.5H21v1.5H3Zm0-5.5v-1.5H21v1.5H3Zm0-5.5v-1.5H21v1.5H3Z';

const Hamburger: FC<HamburgerProps> = (props) => {
    const { isActive, onToggle } = props;
    const pathRef = React.useRef<SVGPathElement>(null);
    const { theme } = useTheme();
    const testIdSuffix = isActive ? 'active' : 'inactive';

    const handleOnClick = React.useCallback((): void => {
        onToggle && onToggle(!isActive);
    }, [isActive, onToggle]);

    React.useEffect(() => {
        anime({
            targets: pathRef.current,
            easing: 'spring(1, 100, 10, 10)',
            duration: 350,
            d: [
                {
                    value: isActive ? hamburgerSolidPath : hamburgerOutlinePath,
                },
            ],
        });
    }, [isActive]);

    return (
        <div
            className={classnames(styles.root, styles[theme], styles.container, isActive && styles.active)}
            onClick={handleOnClick}
            data-testid="hamburger"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                data-testid={`hamburger-${testIdSuffix}`}
            >
                <path d={hamburgerOutlinePath} ref={pathRef} />
            </svg>
        </div>
    );
};

export type { HamburgerProps };
export default Hamburger;
